import PropTypes from 'prop-types'
import React from 'react'

export default function AddUser() {
  return (
    <svg
      width="36"
      height="32"
      fill="none"
      viewBox="0 0 36 32"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.6084 30.6686C2.79909 26.6951 5.86226 25.502 12.8028 25.502C19.7434 25.502 22.8066 26.6951 23.9973 30.6686"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
      />
      <path
        d="M18.8309 14.3071C18.8309 17.6361 16.1322 20.3349 12.8032 20.3349C9.47412 20.3349 6.77539 17.6361 6.77539 14.3071C6.77539 10.978 9.47412 8.2793 12.8032 8.2793C16.1322 8.2793 18.8309 10.978 18.8309 14.3071Z"
        stroke="white"
        strokeWidth="2"
      />
      <path
        d="M28.3027 1.33008V13.508"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M34.3917 7.41905H22.2138"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

AddUser.propTypes = {
  styles: PropTypes.any,
}
